"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/mixins/focus.js
// module id = 141
// module chunks = 15